import { useNavigate } from "react-router";
import qs from "query-string";
import { MultibankingApiProvider } from "@api";

export const useRoutes = () => {
  const navigate = useNavigate();
  const pushSelectBank = (q?: string) => {
    // @ts-ignore
    const params = new URL(window.location).searchParams;
    const type = params.get("type");

    navigate({
      pathname: `/import-bank-connection/select-bank`,
      search: q
        ? `q=${qs.stringify(qs.parse(q))}${type ? `&type=${type}` : ""}`
        : type
          ? `?type=${type}`
          : "",
    });
  };

  const pushImportConnection = (
    id: number | string | undefined,
    multibankingProvider: MultibankingApiProvider,
    wealthApiSlug?: string
  ) => {
    if (multibankingProvider === "WEALTH_API") {
      navigate(`/import-wealth-api-connection/${wealthApiSlug}`);
      return;
    }
    navigate(`/import-bank-connection/${id}`);
  };

  const pushLegalNote = (
    id: number | string | undefined,
    multibankingProvider: MultibankingApiProvider,
    wealthApiSlug?: string
  ) => {
    if (multibankingProvider === "WEALTH_API") {
      navigate(`/import-wealth-api-connection/${wealthApiSlug}`);
      return;
    }
    navigate(`/import-bank-connection/${id}/legal-note`);
  };

  return {
    pushSelectBank,
    pushImportConnection,
    pushLegalNote,
  };
};
